var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section is-size-7"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header has-background-white-ter label is-size-6"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "card-header-icon is-pulled-right"
  }, [_c('b-tooltip', {
    attrs: {
      "label": "Refresh",
      "position": "is-left",
      "type": "is-primary"
    }
  }, [_c('button', {
    staticClass: "button is-rounded is-small has-background-white-ter",
    class: {
      'is-loading click-not-allowed': _vm.isLoadingRefresh
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.getMainData()
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "columns sidespace"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Process")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "select is-small is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.subdepartmentid),
      expression: "filter.subdepartmentid"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter.subdepartmentid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getTlList()
      }]
    }
  }, _vm._l((_vm.subDepartmentList), function(d, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": d.subdepartmentid
      }
    }, [_vm._v(_vm._s(d.subdeptname))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "select is-small is-fullwidth"
  }, [(_vm.isLocationDisabled) ? _c('select', {
    attrs: {
      "disabled": ""
    }
  }, [_c('option', {
    staticClass: "is-capitalized"
  }, [_vm._v("\n                  " + _vm._s(_vm.filter.location.location) + "\n                ")])]) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.location),
      expression: "filter.location"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter.location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getTlList()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.locations), function(l, index) {
    return _c('option', {
      key: index,
      staticClass: "is-capitalized",
      domProps: {
        "value": l
      }
    }, [_vm._v(_vm._s(l.location))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Team Lead")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-fullwidth is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tlemailid),
      expression: "tlemailid"
    }],
    attrs: {
      "disabled": _vm.disableTl
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tlemailid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getAgents()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.tlMaster), function(tl, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": tl.email
      }
    }, [_vm._v(_vm._s(tl.email))])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Agent")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-fullwidth is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agentemailid),
      expression: "agentemailid"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.agentemailid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getMainData()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.agentMaster), function(agent, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": agent.email
      }
    }, [_vm._v(_vm._s(agent.email))])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Agent Status")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-fullwidth is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agentestatus),
      expression: "agentestatus"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.agentestatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getMainData()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.agentStatusList), function(status, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": status.value
      }
    }, [_vm._v(_vm._s(status.name))])
  })], 2)])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-fullwidth sidespace"
  }, [(_vm.tableData.length) ? _c('b-table', {
    staticClass: "custom_table colWidth",
    attrs: {
      "data": _vm.tableData,
      "striped": true
    }
  }, [
    [_c('b-table-column', {
      attrs: {
        "field": "handler",
        "label": "Handler Name"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.props.row.handler) + "\n              ")]), _vm._v(" "), _c('b-table-column', {
      staticClass: "has-text-centered",
      attrs: {
        "field": "allocated",
        "label": "Allocated"
      }
    }, [_c('router-link', {
      class: (_vm.props.row.allocated && !_vm.disableCountClick) ? 'has-text-black-bis' : 'click-not-allowed has-text-black-bis',
      attrs: {
        "target": "_self",
        "title": "Allocated Cases",
        "to": {
          path: '/emailr/emailtracking',
          query: {
            subdepartmentid: _vm.filter.subdepartmentid,
            status: 'allocated',
            toDate: _vm.SendDate.toDate,
            agentemail: _vm.props.row.handler,
            tlemail: _vm.tlemailid
          }
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.props.row.allocated) + "\n                ")])], 1), _vm._v(" "), _c('b-table-column', {
      staticClass: "has-text-centered",
      attrs: {
        "field": "inprocess",
        "label": "In Process"
      }
    }, [_c('router-link', {
      class: (_vm.props.row.inprocess && !_vm.disableCountClick) ? 'has-text-black-bis' : 'click-not-allowed has-text-black-bis',
      attrs: {
        "target": "_self",
        "title": "In Process Cases",
        "to": {
          path: '/emailr/emailtracking',
          query: {
            subdepartmentid: _vm.filter.subdepartmentid,
            status: 'inprocess',
            toDate: _vm.SendDate.toDate,
            agentemail: _vm.props.row.handler,
            tlemail: _vm.tlemailid
          }
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.props.row.inprocess) + "\n                ")])], 1), _vm._v(" "), _c('b-table-column', {
      staticClass: "has-text-centered",
      attrs: {
        "field": "closed",
        "label": "Closed"
      }
    }, [_c('router-link', {
      class: (_vm.props.row.closed && !_vm.disableCountClick) ? 'has-text-black-bis' : 'click-not-allowed has-text-black-bis',
      attrs: {
        "target": "_self",
        "title": "Closed Cases",
        "to": {
          path: '/emailr/emailtracking',
          query: {
            subdepartmentid: _vm.filter.subdepartmentid,
            status: 'close',
            fromDate: _vm.SendDate.fromDate,
            toDate: _vm.SendDate.toDate,
            agentemail: _vm.props.row.handler,
            tlemail: _vm.tlemailid
          }
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.props.row.closed) + "\n                ")])], 1), _vm._v(" "), _c('b-table-column', {
      staticClass: "has-text-centered",
      attrs: {
        "field": "spam",
        "label": "Spam"
      }
    }, [_c('router-link', {
      class: (_vm.props.row.spam && !_vm.disableCountClick) ? 'has-text-black-bis' : 'click-not-allowed has-text-black-bis',
      attrs: {
        "target": "_self",
        "title": "Spam Cases",
        "to": {
          path: '/emailr/emailtracking',
          query: {
            subdepartmentid: _vm.filter.subdepartmentid,
            status: 'Spam',
            fromDate: _vm.SendDate.fromDate,
            toDate: _vm.SendDate.toDate,
            agentemail: _vm.props.row.handler,
            tlemail: _vm.tlemailid
          }
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.props.row.spam) + "\n                ")])], 1), _vm._v(" "), _c('b-table-column', {
      staticClass: "has-text-centered",
      attrs: {
        "field": "status",
        "label": "Agent Status"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.props.row.status || '-') + "\n              ")]), _vm._v(" "), _c('b-table-column', {
      staticClass: "has-text-centered",
      style: ({
        'background-color': _vm.checkMins(_vm.props.row.statusduration)
      }),
      attrs: {
        "field": "statusduration",
        "label": "Agent Status Duration"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#fff"
      }
    }, [_vm._v(_vm._s(_vm.props.row.statusduration))])]), _vm._v(" "), _c('b-table-column', {
      staticClass: "has-text-centered",
      attrs: {
        "field": "outcallcount",
        "label": "Total Out Calls Made"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.props.row.outcallcount || '-') + "\n              ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "rnf",
        "label": "R&F",
        "centered": ""
      }
    }, [(_vm.props.row.status && _vm.props.row.status.toLowerCase() === 'idle') ? _c('span', {
      staticClass: "padding"
    }, [_c('b-tooltip', {
      attrs: {
        "label": _vm.disableCountClick ? _vm.disabledMsg : 'Click to R&F',
        "type": "is-dark"
      }
    }, [_c('button', {
      staticClass: "button is-small is-outlined is-primary",
      attrs: {
        "disabled": _vm.disableCountClick
      },
      on: {
        "click": function($event) {
          _vm.getIvrReasonList(_vm.props.row.handler, _vm.props.row.userid, 2, _vm.props.row.ispaused)
        }
      }
    }, [_vm._v("R")])])], 1) : _vm._e(), _vm._v(" "), (_vm.props.row.inqueue && _vm.props.row.ispaused) ? _c('span', {
      staticClass: "padding"
    }, [_c('b-tooltip', {
      attrs: {
        "label": _vm.disableCountClick ? _vm.disabledMsg : 'Click to Un-pause',
        "type": "is-dark"
      }
    }, [_c('button', {
      staticClass: "button is-small is-warning",
      attrs: {
        "disabled": _vm.disableCountClick
      },
      on: {
        "click": function($event) {
          _vm.getIvrReasonList(_vm.props.row.handler, _vm.props.row.userid, 3, _vm.props.row.ispaused)
        }
      }
    }, [_vm._v("P")])])], 1) : (_vm.props.row.inqueue && !_vm.props.row.ispaused) ? _c('span', {
      staticClass: "padding"
    }, [_c('b-tooltip', {
      attrs: {
        "label": _vm.disableCountClick ? _vm.disabledMsg : 'Click to Pause',
        "type": "is-dark"
      }
    }, [_c('button', {
      staticClass: "button is-small is-primary",
      attrs: {
        "disabled": _vm.disableCountClick
      },
      on: {
        "click": function($event) {
          _vm.getIvrReasonList(_vm.props.row.handler, _vm.props.row.userid, 3, _vm.props.row.ispaused)
        }
      }
    }, [_vm._v("P")])])], 1) : _vm._e()]), _vm._v(" "), _c('b-table-column', {
      staticClass: "has-text-centered",
      attrs: {
        "field": "breaktime",
        "label": "Total Break for the Day"
      }
    }, [_c('span', {
      class: {
        'text-red': _vm.checkHour(_vm.props.row.breaktime)
      }
    }, [_vm._v(_vm._s(_vm.props.row.breaktime || '-'))])])]
  ], 2) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.tableData.length) ? _c('div', {
    staticClass: "is-size-7 has-text-centered no_record"
  }, [_c('p', {
    staticClass: "content has-text-grey"
  }, [_c('b-icon', {
    attrs: {
      "icon": "alert-decagram"
    }
  }), _vm._v("   "), _c('span', {
    staticClass: "is-size-6"
  }, [_vm._v("No Records Found ")])], 1)]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.isReasonModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card search-modal"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [(_vm.reasontype === 2) ? _c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("R&F Reasons")]) : _vm._e(), _vm._v(" "), (_vm.reasontype === 3) ? _c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Pause Reasons")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "delete has-background-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleReasonModal
    }
  })]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitReason()
      }
    }
  }, [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "columns is-multiline is-mobile"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Reason")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-fullwidth is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reasontypeid),
      expression: "reasontypeid"
    }],
    staticClass: "is-capitalized",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reasontypeid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.toggleCommentbox()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.reasonList), function(reason, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": reason.ReasonID
      }
    }, [_vm._v(_vm._s(reason.ReasonText))])
  })], 2)])])])]), _vm._v(" "), (_vm.isCommentboxShow) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('div', {
    staticClass: "control",
    attrs: {
      "cols": "12"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.comment),
      expression: "comment",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input is-small",
    attrs: {
      "size": "sm",
      "placeholder": "Enter comment...",
      "require": _vm.isCommentRequired,
      "disabled": _vm.isCommentboxDisable
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), _vm._m(1)])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "card-header-title"
  }, [_c('strong', [_c('h2', [_vm._v("User Dashboard")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column m-t-20"
  }, [_c('div', {
    staticClass: "is-pulled-right"
  }, [_c('button', {
    staticClass: "button is-small is-primary",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "size": "sm"
    }
  }, [_vm._v("Done")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01275991","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/emailr/EmailrUserDashboard.vue
// module id = 916
// module chunks = 1